import { api } from "./api";

export const listarFormularios = () => api.get("/formulario/listar");
export const obterFormulario = (id) => api.get(`/formulario/${id}`);
export const salvarFormulario = (dto) => api.post("/formulario/salvar", dto);
export const excluirFormulario = (id) => api.post(`/formulario/excluir/${id}`);

// Tipos de resposta suportados pelo questionário configurável.
export const TIPOS_RESPOSTA = [
  { valor: "texto", rotulo: "Texto" },
  { valor: "int", rotulo: "Número inteiro" },
  { valor: "decimal", rotulo: "Número decimal" },
  { valor: "bool", rotulo: "Sim/Não" },
  { valor: "data", rotulo: "Data" },
  { valor: "selecao", rotulo: "Seleção (uma opção)" },
  { valor: "multipla", rotulo: "Múltipla escolha" },
];

export const tipoUsaOpcoes = (tipo) => tipo === "selecao" || tipo === "multipla";
